// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentDeactivateModal__z7E_u {
  width: 720px;
  height: auto;
  display: flex;
  flex-direction: column;
}

.modalBody__QO6PU {
  padding: 16px 24px 24px;
}

.openAiBlock__Nv6eQ {
  margin-bottom: 16px;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.boldText__mlsQM {
  font-weight: 700;
}

.openAiLink__ioxo5 {
  text-decoration: none;
  color: var(--buttons-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.datePickerBlock__FQDuS {
  display: flex;
  margin-top: 8px;
  flex-wrap: wrap;
  row-gap: 25px;
}

.dateTimeBlock__HAAGN {
  display: flex;
  align-items: center;
  position: relative;
  width: 300px;
}

.dateRangeSeparator__urRe9 {
  color: var(--selection-controls-radio-text);
  margin: 10px 8px 0;
}

.calendarIcon__qAkci {
  position: absolute;
  bottom: 10px;
  right: 13px;
}

.infoIcon__Rmpzg {
  outline: none;
  margin-left: 10px;
  margin-top: 10px;
}

.reminderInfoIcon__y3iRm {
  margin-left: 10px;
  margin-top: 5px;
  outline: none;
}

.reasonBlock__CJcUh {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 9px;
  width: 100%;
}

.loader__rEVSx > img {
  width: 70px;
}

.modalFooter__ATVP8 {
  display: flex;
  justify-content: flex-end;
  padding: 0 24px 24px;
}
.modalFooter__ATVP8 :last-child {
  margin-left: 24px;
}

.warningText__fmhIb {
  color: var(--tables-secondary-row-sub-title-text);
}

.warningTriggeredText__yQ44D {
  color: var(--inputs-error-stroke);
}

.reminderBlock__G7OQR {
  flex: 1 0 100%;
  max-width: 325px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EquipmentDeactivateModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAzEF;;AA4EA;EACE,uBAAA;AAzEF;;AA4EA;EACE,mBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,qBAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,2CAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;AAzEF;;AA6EE;EACE,WAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;AA3EF;AA6EE;EACE,iBAAA;AA3EJ;;AA+EA;EACE,iDAAA;AA5EF;;AA+EA;EACE,iCAAA;AA5EF;;AA+EA;EACE,cAAA;EACA,gBAAA;AA5EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentDeactivateModal {\n  width: 720px;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.modalBody {\n  padding: 16px 24px 24px;\n}\n\n.openAiBlock {\n  margin-bottom: 16px;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.boldText {\n  font-weight: 700;\n}\n\n.openAiLink {\n  text-decoration: none;\n  color: var(--buttons-text-secondary);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.datePickerBlock {\n  display: flex;\n  margin-top: 8px;\n  flex-wrap: wrap;\n  row-gap: 25px;\n}\n\n.dateTimeBlock {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 300px;\n}\n\n.dateRangeSeparator {\n  color: var(--selection-controls-radio-text);\n  margin: 10px 8px 0;\n}\n\n.calendarIcon {\n  position: absolute;\n  bottom: 10px;\n  right: 13px;\n}\n\n.infoIcon {\n  outline: none;\n  margin-left: 10px;\n  margin-top: 10px;\n}\n\n.reminderInfoIcon {\n  margin-left: 10px;\n  margin-top: 5px;\n  outline: none;\n}\n\n.reasonBlock {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin-top: 9px;\n  width: 100%;\n}\n\n.loader {\n  & > img {\n    width: 70px;\n  }\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 24px 24px;\n\n  :last-child {\n    margin-left: 24px;\n  }\n}\n\n.warningText {\n  color: var(--tables-secondary-row-sub-title-text);\n}\n\n.warningTriggeredText {\n  color: var(--inputs-error-stroke);\n}\n\n.reminderBlock {\n  flex: 1 0 100%;\n  max-width: 325px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentDeactivateModal": `equipmentDeactivateModal__z7E_u`,
	"modalBody": `modalBody__QO6PU`,
	"openAiBlock": `openAiBlock__Nv6eQ`,
	"boldText": `boldText__mlsQM`,
	"openAiLink": `openAiLink__ioxo5`,
	"datePickerBlock": `datePickerBlock__FQDuS`,
	"dateTimeBlock": `dateTimeBlock__HAAGN`,
	"dateRangeSeparator": `dateRangeSeparator__urRe9`,
	"calendarIcon": `calendarIcon__qAkci`,
	"infoIcon": `infoIcon__Rmpzg`,
	"reminderInfoIcon": `reminderInfoIcon__y3iRm`,
	"reasonBlock": `reasonBlock__CJcUh`,
	"loader": `loader__rEVSx`,
	"modalFooter": `modalFooter__ATVP8`,
	"warningText": `warningText__fmhIb`,
	"warningTriggeredText": `warningTriggeredText__yQ44D`,
	"reminderBlock": `reminderBlock__G7OQR`
};
module.exports = ___CSS_LOADER_EXPORT___;
